module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ;  _.each(locals.headings, function(h, i) { 
    ; __append(" <div class=\"list__body__item__heading ")
    ; __append(escapeFn( h.computeClass(locals.model) ))
    ; __append("\" data-heading-index=\"")
    ; __append(escapeFn( i ))
    ; __append("\"> ")
    ;  if (h.subView) { 
    ; __append(" <div id=\"")
    ; __append(escapeFn( locals.computeHeadingId(locals.model.get('id'), h.display) ))
    ; __append("\"></div> ")
    ;  } else { 
    ; __append(" <span> ")
    ; __append(escapeFn( locals.getTextFromHeading(locals.model, h) ))
    ; __append(" </span> ")
    ;  } 
    ; __append(" </div> ")
    ;  });
    ; __append(" ")
    ;  if (locals.showDetails) { 
    ; __append(" <div class=\"hidden-xs col-sm-2 text-center\"> <a href class=\"list__body__item__show_details text-nowrap\">Details <span class=\"caret\"></span></a> </div> <div class=\"list__body__item__details col-xs-12\"> <div id=\"")
    ; __append(escapeFn( locals.computeDetailsId(locals.model.get('id')) ))
    ; __append("\"></div> </div> ")
    ;  } 
    ; __append(" ")
    ;  if (locals.subItemsArray.length) { 
    ; __append(" <div id=\"")
    ; __append(escapeFn( locals.uid ))
    ; __append("-subitems\" class=\"col-xs-12 list__body__item__subitems\"></div> ")
    ;  } 
    ; __append(" ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/list/item/template.ejs
// module id = 816
// module chunks = 1